import { render } from "./ButtonLinkComponent.vue?vue&type=template&id=20fb0c96&scoped=true"
import script from "./ButtonLinkComponent.vue?vue&type=script&lang=js"
export * from "./ButtonLinkComponent.vue?vue&type=script&lang=js"

import "./ButtonLinkComponent.vue?vue&type=style&index=0&id=20fb0c96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20fb0c96"]])

export default __exports__